import { render, staticRenderFns } from "./CollectionJournal.vue?vue&type=template&id=73fb715e&"
import script from "./CollectionJournal.vue?vue&type=script&lang=js&"
export * from "./CollectionJournal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports